// ============================================================
// lib/fix.js — a picture sent from the free checker ("Fix in Gov Social Kit").
//
// The checker runs on the county's own page. It opens /fix here and posts
// the picture (a PNG data URL, when the browser lets it read the picture)
// with what it found. The picture is held until the workspace is open (the
// person may need to log in first), then FixPanel uses it.
//
// Messages come from any site, so only these fields are kept, each checked.
// ============================================================

const KEY = "gsk-fix";
let held = null;

const str = (v, max) => (typeof v === "string" ? v.slice(0, max) : "");
const httpUrl = (v) => (typeof v === "string" && /^https?:\/\/[^\s"<>]+$/i.test(v) && v.length <= 2000 ? v : "");

export function cleanFix(d) {
  if (!d || typeof d !== "object" || d.type !== "gsk-fix-image") return null;
  const dataUrl = typeof d.dataUrl === "string" && /^data:image\/(png|jpeg|webp);base64,[a-z0-9+/=]+$/i.test(d.dataUrl) && d.dataUrl.length < 12e6 ? d.dataUrl : "";
  return {
    dataUrl, src: httpUrl(d.src), page: httpUrl(d.page), alt: str(d.alt, 600), issue: str(d.issue, 200),
    auto: Boolean(d.auto), at: Date.now(),
  };
}

/** Keeps a picture from the checker (in this tab, through a login). */
export function holdFix(fix) {
  held = fix;
  try { sessionStorage.setItem(KEY, JSON.stringify(fix)); } catch { /* too big for storage: kept in memory */ }
  window.dispatchEvent(new Event("gsk-fix"));
}

/** The picture waiting to be fixed, or null. */
export function heldFix() {
  if (held) return held;
  try { const saved = JSON.parse(sessionStorage.getItem(KEY) || "null"); return saved ? cleanFix({ ...saved, type: "gsk-fix-image" }) : null; } catch { return null; }
}

export function clearFix() {
  held = null;
  try { sessionStorage.removeItem(KEY); } catch { /* nothing to clear */ }
}

/** Listens for the checker's picture (on /fix only), and answers so it stops sending. */
export function listenForFix() {
  if (!window.location.pathname.startsWith("/fix")) return;
  window.addEventListener("message", (event) => {
    const fix = cleanFix(event.data);
    if (!fix) return;
    holdFix(fix);
    try { if (event.source) event.source.postMessage({ type: "gsk-fix-ack" }, event.origin || "*"); } catch { /* the other tab closed */ }
  });
}
